import { ROUTES } from 'constants/routes'
import * as Pages from 'pages'
import type { RouteObject } from 'react-router-dom'

import { PrivateRoute } from './private'

const interReservationRoutes: RouteObject[] = [
  {
    path: ROUTES.INTER_RESERVATION.CREATE_WEBHOOK_PIX,
    element: (
      <PrivateRoute>
        <Pages.CreateWebhookPix />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.INTER_RESERVATION.LIST_WEBHOOK_PIX,
    element: (
      <PrivateRoute>
        <Pages.ListWebhookPix />
      </PrivateRoute>
    ),
  },
]

export default interReservationRoutes
